import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { StorageService } from "../../services/storage.service";
import Swal from "sweetalert2";
import { AppLogo2, ClgLogo } from "src/app/app.config";

@Component({
  selector: "app-update-password",
  templateUrl: "./update-password.component.html",
  styleUrls: ["./update-password.component.css"],
})
export class UpdatePasswordComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  passwordForm: FormGroup;
  appLogo = AppLogo2;
  clgLogo = ClgLogo;
  user_id = this.ls.get("user_id");
  submitted = false;
  passwordchange: Response;
  hide = true;

  constructor(
    private storageService: StorageService,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.passwordForm = this.fb.group(
      {
        user_id: this.user_id,

        new_password: [
          "",
          [
            Validators.required,
            Validators.minLength(3),
            Validators.pattern(/^(?!.*\s).*$/),
          ],
        ],
        confirm_new_password: ["", Validators.required],
      },
      { validators: this.checkPassword }
    );
  }
  checkPassword(form: FormGroup) {
    if (form.value.new_password == form.value.confirm_new_password) {
      return null;
    }
    form.controls.confirm_new_password.setErrors({ notSame: true });
    return { notSame: true };
  }
  get passwordvalid() {
    return this.passwordForm.controls;
  }
  async changePassword(form: FormGroup) {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    }
    this.spinner.show();

    let requestObject = {
      id: this.ls.get("user_id"),
      password: form.value.new_password,
      key: this.ls.get("key"),
    };

    if (this.ls.get("password") == 0) {
      let data = {
        user_id: this.ls.get("user_id"),
        password: form.value.new_password,
        new_password: form.value.new_password,
        confirm_password: form.value.confirm_new_password,
      };
      this.passwordchange = await this.globalService.create(
        "user/change-new-password",
        data
      );
    } else {
      this.passwordchange = await this.globalService.create(
        "user/reset-forgot-password",
        requestObject
      );
    }

    let pw = this.passwordchange["content"];

    if (this.passwordchange["status"] === 200) {
      this.spinner.hide();
      this.passwordForm.reset();
      this.submitted = false;
      Swal.fire("Success!", "Password Changed Successfully!", "success");
      this.ls.remove("key");
      this.ls.remove("role");
      this.ls.remove("user_id");
      this.ls.remove("password");
      this.router.navigate([""]);
    }
  }
}
